<template>
  <div class="">
    <div class="parallelogram">
      <img alt="Brand" class="mainLogo" :src="require('@/assets/img/logo.png')" />
    </div>
    <div class="vertical-rounded-tab">
      <div class="subLogo">
        <small>Powered by</small>&nbsp;<img :src="require('@/assets/img/CIC.png')" alt="" />
      </div>
    </div>
    <video autoplay muted loop playsinline class="myVideo">
      <!-- https://zsurvey.kuteone.com/public/media/online-video-cutter.68c1caed.mp4 -->
      <source :src="require('@/assets/videos/online-video-cutter_1.mp4')" type="video/mp4" />
      <!-- <source src="https://zsurvey.kuteone.com/public/media/online-video-cutter.68c1caed.mp4" type="video/mp4" /> -->
      
      Your browser does not support HTML5 video.
    </video>
    <div class="homePanel">
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <h4 class="text-center"><span>SURVEY OF</span> INTERNATIONAL AIR TRAVELERS</h4>
          <strong>DEPARTING THE UNITED STATES</strong><br /><br />
          <a type="button" class="btn btn-default btn-red" @click="startSurvey">Next <i class="fas fa-plane"></i></a>
          <p class="text-danger" v-if="!hasQrCode">Invalid QR code</p>
          <p class="text-danger" v-if="restrictSubmission">You can only submit once every 5 minutes.</p>
           <p class="omb-control">OMB CONTROL NO. 0625-0227</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import surveyService from '@/services/surveyService';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const hasQrCode = ref(false);
    const surveySubmitted = ref(false);
    const restrictSubmission = ref(false);

    onMounted(() => {
      console.log("Route query:", route.query);
      
      hasQrCode.value = !!route.query.qrcode;
      const storedSurveySubmitted = localStorage.getItem("surveySubmitted");
      const storedSubmissionTime = localStorage.getItem("submissionTime");

      surveySubmitted.value = storedSurveySubmitted === "true";
      restrictSubmission.value = storedSubmissionTime && new Date().getTime() - new Date(storedSubmissionTime).getTime() < 5 * 60 * 1000;

      if(surveySubmitted.value && restrictSubmission.value){
        router.push({ path: 'stage/6/success' });
      }
    });

    const startSurvey = () => {
      if (hasQrCode.value && !restrictSubmission.value) {
        // CRITICAL: Reset survey answers from previous submission
        surveyService.reset();
        
        localStorage.setItem('qrcode', route.query.qrcode);
        surveyService.generateUniqueId();
        router.push({ name: 'SurveyHome' });
      }
    };

    return { startSurvey, hasQrCode, restrictSubmission };
  },
};
</script>

<style>
.omb-control {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1rem;
  margin: 0;
}
</style>